/**
 * @generated SignedSource<<ceb14474092555c6c4c59ad44cde2ea0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
import { FragmentRefs } from "relay-runtime";
export type WidgetTeamScheduleInlineRoutineListItem_TeamScheduleInlineRoutineOccasion$data = {
  readonly id: string;
  readonly taskExecution: {
    readonly checkValue: TaskSentiment | null;
    readonly id: string;
    readonly routine: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleRoutineListItemContent_Routine">;
    } | null;
    readonly routineOccasion: {
      readonly id: string;
      readonly sequenceNumber: number;
      readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionStatusCircleInline_RoutineOccasion" | "WidgetTeamScheduleRoutineIssueIndicator_routineOccasion" | "WidgetTeamScheduleRoutineListItemContent_RoutineOccasion">;
    };
    readonly sectionId: string;
    readonly task: {
      readonly id: string;
    };
  };
  readonly " $fragmentType": "WidgetTeamScheduleInlineRoutineListItem_TeamScheduleInlineRoutineOccasion";
};
export type WidgetTeamScheduleInlineRoutineListItem_TeamScheduleInlineRoutineOccasion$key = {
  readonly " $data"?: WidgetTeamScheduleInlineRoutineListItem_TeamScheduleInlineRoutineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleInlineRoutineListItem_TeamScheduleInlineRoutineOccasion">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTeamScheduleInlineRoutineListItem_TeamScheduleInlineRoutineOccasion",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskExecutionCheck",
      "kind": "LinkedField",
      "name": "taskExecution",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "TaskCheck",
          "kind": "LinkedField",
          "name": "task",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sectionId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineOccasion",
          "kind": "LinkedField",
          "name": "routineOccasion",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sequenceNumber",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetTeamScheduleRoutineListItemContent_RoutineOccasion"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetTeamScheduleRoutineIssueIndicator_routineOccasion"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RoutineOccasionStatusCircleInline_RoutineOccasion"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Routine",
          "kind": "LinkedField",
          "name": "routine",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetTeamScheduleRoutineListItemContent_Routine"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "checkValue",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TeamScheduleInlineRoutineOccasion",
  "abstractKey": null
};
})();

(node as any).hash = "6a300b43fea66877967738cb95ac3349";

export default node;
